import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "@mui/material";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../../Base/Components/Card/Card";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API---------------------------
import { obtenerUnitsAct } from "../../../../../Base/API/Global/UnidadesMedida/UnitRequests";
import { getProveedorAct } from "../../../../../API/Compras/Proveedores/ProveedoresRequest";
import { getAreasAct } from "../../../../../Base/API/Global/Areas/AreasRequests";
import { getMotoristas } from "../../../../../API/Global/Motoristas/MotoristasRequest";
import { getTypesCategoria } from "../../../../../Base/API/Global/Types/TypeRequest";
import { getVehiculos } from "../../../../../API/Global/Vehiculos/VehiculosRequest";
import { EditarPase, getDetallePorId, getDetallePorNo, getEncabezadoPorId, getEncabezadoPorNo, getUserSolicitarPase, GuardarPase, ObtenerSiguienteNoPase } from "../../../../../API/Logistica/PasesSalidaRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import ProductosOverlayPanel from "../../../Compras/Requisas/CrudRequisa/OverlayPanels/ProductoOverlayPanel";
import EncabezadoPase from "./EncabezadoPase";
import OverlayActivos from "./OverlayActivos";
import OverlayIngresos from "./OverlayIngresos";

const PasesSalidaCRUD = ({ selectedEnc, habilitar, setHabilitar, getInfo }) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [areas, setareas] = useState([]);
  const [userSolicitar, setUserSolicitar] = useState([]);
  const [motivos, setMotivos] = useState([]);
  const [motoristas, setMotoristas] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const [units, setUnits] = useState([]);
  const [proveedor, setProveedor] = useState([]);
  const [habilitarRetorno, setHabilitarRetorno] = useState(true);

  const initialValues = {
    IdPase: -1,
    FechaCreacion: new Date(),
    FechaRetornoTent: new Date(),
    IdEstado: 58,
    StatusName: "Solicitado",
    NoPaseSalida: selectedEnc[0]?.NoPaseSalida ? selectedEnc[0]?.NoPaseSalida : "",
    Comentario: "",
    Direccion: '',
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  const getInfo2 = async (selectedEnc) => {
    setLoading(true);
    const Npase = await ObtenerSiguienteNoPase();

    const areasActivas = await getAreasAct();
    setareas(areasActivas);

    const userSolicitanTempo = await getUserSolicitarPase();
    setUserSolicitar(userSolicitanTempo);

    const motoristasTempo = await getMotoristas();
    setMotoristas(motoristasTempo);

    const motivosTempo = await getTypesCategoria("Motivos");
    setMotivos(motivosTempo);

    const vehiculosTempo = await getVehiculos();
    setVehiculos(vehiculosTempo);

    const proveedorTempo = await getProveedorAct()
    setProveedor(proveedorTempo)

    const u = await obtenerUnitsAct();
    setUnits(u);


    if(selectedEnc.length <= 0){
      const d = {
        ...values,
        IdPase: -100,
        NoPaseSalida: Npase[0]?.NumPaseSalida,
        FechaRetornoTent: new Date(),
      };

      setValues(d);
      setHabilitar(true);
    }else{
      const encabezadoTempo = await getEncabezadoPorId(selectedEnc?.IdPase)

      const detallesTempo = await getDetallePorId(selectedEnc?.IdPase)
      setDetalles(detallesTempo)
      if(encabezadoTempo.length > 0){
        const [encabezado] = encabezadoTempo

        const n ={
          ...encabezado,
          FechaCreacion: new Date(encabezado?.FechaCreacion),
          selectedOption: encabezado?.Sale,
          Direccion: encabezado?.Direccion ? encabezado?.Direccion : '',
        }
        setValues(n)
        setHabilitar(false);
        setHabilitarRetorno(true)
      }
    }
    setLoading(false);
  };

  const informacionDropdown = async (info) => {
    const motoristasTempo = await getMotoristas();
    setMotoristas(motoristasTempo);

    const motivosTempo = await getTypesCategoria("Motivos");
    setMotivos(motivosTempo);

    const vehiculosTempo = await getVehiculos();
    setVehiculos(vehiculosTempo);

    if(info){
      let NoPase = info?.NoPaseSalida
      if(NoPase){
        const resp = await getEncabezadoPorNo(NoPase)
        if(resp.length > 0){
          setLoading(true)
          setValues({
            ...resp[0],
            Comentario: resp[0]?.Comentario ? resp[0]?.Comentario: '',
            Direccion: resp[0]?.Direccion ? resp[0]?.Direccion : '',
            FechaCreacion: new Date(resp[0]?.FechaCreacion),
            selectedOption: resp[0]?.Sale
          })
          const detallesTempo = await getDetallePorNo(NoPase)
          setDetalles(detallesTempo)
          setLoading(false)
        }else{
          toastShow(toast, 'warn', 'Advertencia', 'No se encontro el Pase de Salida')
          getInfo2(selectedEnc)
        }
      }
    }
    
  };

  const guardarPase = async () => {
    let guardar = true
    if (detalles.length === 0) {
      toastShow(toast,"error", "Error", "Debe agregar al menos un detalle.");
      guardar = false
    }else{
      detalles.forEach((d) => {
        switch (values?.selectedOption) {
            case 'Otro':
                if (!d.Comentario) {
                    toastShow(toast, "error", "Error", "Todos los items deben contener un comentario.");
                    guardar = false
                }
                break;
            case 'IsProducto':
                if (d.IdProducto === null) {
                    toastShow(toast, "error", "Error", "Todos los items deben contener un Producto.");
                    guardar = false
                }
                break;
            case 'IsActivo':
                if (d.IdActivo === null) {
                    toastShow(toast, "error", "Error", "Todos los items deben contener un Activo Fijo.");
                    guardar = false
                }
                break;
            case 'IsIngreso':
                if (d.IdIngresoDetalle === null) {
                    toastShow(toast, "error", "Error", "Todos los items deben contener un Ingreso.");
                    guardar = false
                }
                break;
            default:
                break;
        }         
        if(!d.IdUnit && !d.IdUnir){
          toastShow(toast,"error", "Error", "Debe agregar la Unidad.");
          guardar = false;
          return
        }
        if (d.Retorna === true && !d.FechaRetornoTent) {
          toastShow(toast, "error", "Error", "Debe agregar la Fecha Tentativa de Retorno.");
          guardar = false;
        }
        if(d.Peso === 0){
          toastShow(toast, "error", "Error", "El peso debe ser mayor a 0.");
          guardar = false;
          return
        }
        if(d.Cantidad === 0){
          toastShow(toast, "error", "Error", "La cantidad debe ser mayor a 0.");
          guardar = false;
        }
      })
    }

    if(guardar){
      setLoading(true)

      const Encabezado = {
        IdPase: values?.IdPase,
        IdUserSolicita: values?.UserNameSolicita?.IdUser || values?.IdUserSolicita,
        IdArea: values?.Area?.IdArea || values?.IdArea,
        IdEstado: 58,
        IdMotorista: values?.NombreCompletoMotorista?.IdMotorista || values?.IdMotorista,
        NombreDestino: values?.CustomerName?.CustomerName || values?.NombreDestino,
        Direccion: values?.CustomerName?.Address ||values?.Direccion,
        IdDestino: values?.CustomerName?.IdVendor || values?.IdDestino,
        IdMotivo: values?.Motivo?.IdType || values?.IdMotivo,
        Comentario: values?.Comentario,
        IdVehiculo: values?.VehiculoCompleto?.IdVehiculo|| values?.IdVehiculo,
        IdUserEdit: userAuth?.IdUser,
        IdUserCreate: userAuth?.IdUser,
        Sale: values?.selectedOption
      }

      const detalles1 = detalles.map((detalle) => ({
        ...detalle[0],
        IdPaseDet: detalle.IdPaseDet,
        IdPase: values.IdPase,
        Cantidad: detalle.Cantidad,
        IdProducto: detalle.IdProducto,
        IdActivo: detalle.IdActivo,
        IdIngresoDetalle: detalle.IdIngresoDetalle,
        Comentario: detalle.Comentario,
        Peso: detalle.Peso,
        IdUnir: detalle.IdUnit || detalle?.IdUnir,
        IdUserEdit: userAuth?.IdUser,
        IdUserCreate: userAuth?.IdUser,
        Descripcion: detalle.Descripcion,
        Retorna: detalle?.Retorna ? detalle?.Retorna : false,
        FechaRetornoTent: detalle?.Retorna ? detalle?.FechaRetornoTent : null,
        FechaRetorno: detalle?.FechaRetorno ? detalle?.FechaRetorno : null,
        Retorno: detalle?.FechaRetorno ? true : false,
      }));

      if(values?.IdPase > 0){
          const respuestaDetalles = await EditarPase(Encabezado, detalles1)
          if (respuestaDetalles[0]?.ESTADO !== -1) {
            setHabilitar(false);
            toastShow(toast, "success", "Editado", respuestaDetalles[0].MENSAJE);
            getInfo(respuestaDetalles[0])
            getInfo2(respuestaDetalles[0])
            setLoading(false);
          } else {
            toastShow( toast, "error", "Error", respuestaDetalles[0].MENSAJE);
            setLoading(false);
          }
      }else{
        const respuestaDetalles = await GuardarPase(Encabezado, detalles1)
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAJE);
          getInfo()
          getInfo2(respuestaDetalles[0])
          setLoading(false);
        } else {
          toastShow( toast, "error", "Error", respuestaDetalles[0].MENSAJE);
          setLoading(false);
        }
      }
      setLoading(false)
    }

  };

  const agregarNuevaFila = () => {
    let newRowData = [...detalles];

    let IdDet = -(detalles?.length + 1);
    const newData = {
      IdPaseDet: IdDet,
      FechaCreacion2: new Date(),
      NoPaseSalida: values?.NoPaseSalida,
      IdProducto: null,
      CodigoProducto: "",
      NombreProducto: "",
      IdActivo: null,
      CodigoActivo: "",
      NombreActivo: "",
      IdIngresoDetalle: null,
      NumeroIngreso: "",
      Descripcion: "",
      IdEstado: 58,
      IdUnit: "",
      UnitName: "",
      Cantidad: 0,
      Peso: 0,
      Comentario: "",
      Descripcion: "",
    };
    newRowData.push(newData);
    setDetalles(newRowData);
  };

  const changeActivo = ({ data }) => {
    return (
      <OverlayActivos
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdPaseDet === rowData.IdPaseDet
          );

          const isAlreadyAdded = detalles.some(
            (detail) => detail.IdActivo === data.IdActivo
          );

          if (isAlreadyAdded) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "El activo seleccionado ya existe en este pase de salida"
            );
            return;
          }
          let newDetail = [...detalles];
          newDetail[index].IdActivo = data.IdActivo;
          newDetail[index].CodigoActivo = data.CodigoActivo;
          newDetail[index].NombreActivo = data.NombreActivo;
          newDetail[index].Marca = data.Marca;
          newDetail[index].Modelo = data.Modelo;
          newDetail[index].Ano = data.Ano;
          newDetail[index].Serie = data.Serie;
          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const changeProducto = ({ data }) => {
    return (
      <ProductosOverlayPanel
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdPaseDet === rowData.IdPaseDet
          );
          let newDetail = [...detalles];
          newDetail[index].IdProducto = data.IdProduct;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].DescripcionProducto = data.DescripcionProducto;
          newDetail[index].NombreTipoProducto = data.NombreTipoProducto;
          newDetail[index].NombreCategoria = data.NombreCategoria;
          newDetail[index].NombreSubcategoria = data.NombreSubcategoria;
          newDetail[index].IdUnit = data.IdUnit;
          newDetail[index].UnitName = data.UnitName;
          setDetalles(newDetail);
          api.stopEditing();
        }}
        code={1}
      />
    );
  };

  const changeIngreso = ({ data }) => {
    return (
      <OverlayIngresos
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdPaseDet === rowData.IdPaseDet
          );

          const isAlreadyAdded = detalles.some(
            (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
          );

          if (isAlreadyAdded) {
            toastShow( toast, "warn", "Advertencia", "El ingreso seleccionado ya existe en este pase de salida" );
            return;
          }
          let newDetail = [...detalles];
          newDetail[index].IdIngresoDetalle = data.IdIngresoDetalle;
          newDetail[index].NumeroIngreso = data.NumeroIngreso;
          newDetail[index].IdProduct = data.IdProducto;
          newDetail[index].CodigoProductoI = data.CodigoProducto;
          newDetail[index].NombreProductoI = data.NombreProducto;
          newDetail[index].DescripcionProductoI = data.DescripcionProducto;
          newDetail[index].NombreTipoProductoI = data.NombreTipoProducto;
          newDetail[index].NombreCategoriaI = data.NombreCategoria;
          newDetail[index].NombreSubcategoriaI = data.NombreSubcategoria;
          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const changeUnidad = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={units.filter((e) => e.IdUnit === data.IdUnit)[0]}
          options={units}
          optionLabel="UnitName"
          filter
          filterBy="UnitName"
          onChange={(e) => {
            if (selected.length > 0) {
              let tempo2 = [...detalles];
              selected.forEach((select) => {
                const index = tempo2.findIndex((detail) =>detail.IdPaseDet ===select.IdPaseDet);
                tempo2[index].IdUnit = e.value.IdUnit;
                tempo2[index].UnitName = e.value.UnitName;
              });
              setDetalles(tempo2);
            } else {
              let newDetail = [...detalles];
              const index = detalles.findIndex((detail) => detail.IdPaseDet ===data.IdPaseDet);
              newDetail[index].IdUnit = e.value.IdUnit;
              newDetail[index].UnitName = e.value.UnitName;
              setDetalles(newDetail);
            }
          }}
        />
      </div>
    );
  };

  const changeComentario = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdPaseDet === data.IdPaseDet);
    let newDetail = [...detalles];
    if (column.field === "Comentario") {
      newDetail[index].Comentario = data.Comentario;
    }
    setDetalles(newDetail);
  };

  const changeDescripcion = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdPaseDet === data.IdPaseDet);
    let newDetail = [...detalles];
    if (column.field === "Descripcion") {
      newDetail[index].Descripcion = data.Descripcion;
    }
    setDetalles(newDetail);
  };

  const handleCheckboxChange = (rowData, checked) => {
    const index = detalles.findIndex((detail) => detail.IdPaseDet === rowData.IdPaseDet );
    const updatedDetalles = [...detalles];
    updatedDetalles[index].Retorna = checked;

    setDetalles(updatedDetalles);
  };

  const changeCantidad = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdPaseDet === data.IdPaseDet);
    let newDetail = [...detalles];
    if (column.field === "Cantidad") {
        newDetail[index].Cantidad = data.Cantidad;
        setDetalles(newDetail);
    }  
  };

  const changePeso = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdPaseDet === data.IdPaseDet);
    let newDetail = [...detalles];
    if (column.field === "Peso") {
        newDetail[index].Peso = data.Peso;
        setDetalles(newDetail);
    }  
  };

  const columns = [
    {
      // ID
      field: "IdPaseDet",
      header: "ID",
      headerEn: "ID",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      // FechaPermiso4
      field: "FechaCreacion2",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "small",
      frozen: true,
    },
    {
      // PurchaseRequest
      field: "NoPaseSalida",
      headerEn: "No. Pase",
      header: "No. Pase",
      className: "small",
      body: (rowData) => rowData.NoPaseSalida,
      Format: "Modal",
      align: "center",
      frozen: true,
      Sumary: "count",
      onCellDoubleClicked: ({ data }) => {
        // Requisa(data.NoPaseSalida);
      },
    },

    //ACTIVO
    {
      // Area
      field: "CodigoActivo",
      header: "Codigo Act",
      headerEn: "Code Ac",
      className: "small",
      hidden: values?.selectedOption === "IsActivo",
      editable: habilitar,
      cellEditor: changeActivo,
    },
    {
      // Area
      field: "NombreActivo",
      header: "Activo",
      headerEn: "Activo",
      hidden: values?.selectedOption === "IsActivo",
      className: "large",
    },
    {
      header: "Marca",
      headerEn: "Marca",
      hidden: values?.selectedOption === "IsActivo",
      field: "Marca",
    },
    {
      header: "Modelo",
      hidden: values?.selectedOption === "IsActivo",
      headerEn: "Modelo",
      field: "Modelo",
    },
    {
      header: "Año",
      hidden: values?.selectedOption === "IsActivo",
      headerEn: "Year",
      field: "Ano",
      className: "Xsmall",
    },
    {
      header: "Serie",
      hidden: values?.selectedOption === "IsActivo",
      headerEn: "Serie",
      field: "Serie",
    },

    //PRODUCTO
    {
      // Area
      field: "CodigoProducto",
      header: "Codigo",
      hidden: values?.selectedOption === "IsProducto",
      headerEn: "Code",
      className: "small",
      editable: habilitar,
      cellEditor: changeProducto,
    },
    {
      field: "NombreProducto",
      header: "Producto",
      hidden: values?.selectedOption === "IsProducto",
      headerEn: "Producto",
      className: "large",
    },
    {
      field: "DescripcionProducto",
      header: "Descripción",
      hidden: values?.selectedOption === "IsProducto",
      headerEn: "Description",
      className: "large",
    },
    {
      header: "Tipo Producto",
      hidden: values?.selectedOption === "IsProducto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "small",
    },
    {
      header: "Categoría",
      hidden: values?.selectedOption === "IsProducto",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "medium",
    },
    {
      header: "Sub-Categoría",
      hidden: values?.selectedOption === "IsProducto",
      headerEn: "Sub-Category",
      field: "NombreTipoProducto",
      className: "medium",
    },

    //INGRESO
    {
      field: "NumeroIngreso",
      hidden: values?.selectedOption === "IsIngreso",
      header: "Ingreso",
      headerEn: "Income",
      className: "small",
      editable: habilitar,
      cellEditor: changeIngreso,
    },
    {
      // Comment
      field: "CodigoProductoI",
      header: "Código",
      headerEn: "Code",
      hidden: values?.selectedOption === "IsIngreso",
      // frozen: true,
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // Comment
      field: "NombreProductoI",
      header: "Nombre Producto",
      hidden: values?.selectedOption === "IsIngreso",
      headerEn: "Product Name",
      className: "Xlarge",
    },
    {
      // Comment
      field: "NombreCategoriaI",
      header: "Tipo Producto",
      hidden: values?.selectedOption === "IsIngreso",
      headerEn: "Product Type",
      className: "small",
    },
    {
      // Comment
      field: "NombreSubcategoriaI",
      header: "Categoría",
      hidden: values?.selectedOption === "IsIngreso",
      headerEn: "Category",
      className: "small",
    },
    {
      // Comment
      field: "NombreTipoProductoI",
      header: "Categoría",
      headerEn: "Category",
      hidden: values?.selectedOption === "IsIngreso",
      className: "small",
    },

    //OTRO
    {
      field: "Comentario",
      hidden: values?.selectedOption === "Otro",
      header: "Comentario",
      headerEn: "Comment",
      className: "XXXlarge",
      editable: habilitar,
      onChange: (data) => changeComentario(data),
    },

    {
      field: "Peso",
      header: "Peso",
      headerEn: "Peso",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      editable: habilitar,
      onChange: (data) => changePeso(data),
    },
    {
      field: "Cantidad",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      editable: habilitar,
      onChange: (data) => changeCantidad(data),
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      editable: habilitar,
      cellEditor: changeUnidad,
    },
    {
      // Comment
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      className: "XXlarge",
      minWidth: 250,
      flex: 1,
      editable: habilitar,
      onChange: (data) => changeDescripcion(data),
    },

    //RETORNA
    {
      field: "Retorna",
      Format: "Template",
      header: "Retorna",
      align: "center",
      className: "Xsmall",
      filter: false,
      body: (rowData, rowIndex) => (

        <Checkbox
        style={{
          padding: "0px",
          marginBottom: "4px",
          alignContent: "center",
        }}
        checked={rowData?.Retorna}
        disabled={!habilitar}
        onChange={(e) => handleCheckboxChange(rowData, e.target.checked)}
      />
        // rowData.Retorna ?
        //   <Checkbox
        //     style={{
        //       padding: "0px",
        //       marginBottom: "4px",
        //       alignContent: "center",
        //     }}
        //     checked={rowData?.Retorna}
        //     disabled={!habilitar}
        //     onChange={(e) => handleCheckboxChange(rowData, e.target.checked)}
        //   /> : null
      ),
    },
    {
      header: "Fecha Tent. Retorno",
      handerEn: "Start Week",
      field: "FechaRetornoTent",
      className: "medium",
      Format: "DateDisabled",
      editable: (rowData) => rowData.data?.Retorna === true && habilitar
    },
    {
      header: "Fecha Retorno",
      handerEn: "Start Week",
      field: "FechaRetorno",
      className: "medium",
      Format: "DateDisabled",
      hidden: values?.IdEstado === 62,
      // editable: (rowData) => rowData.data?.Retorna === true && !habilitarRetorno
    },

  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => showModal(e),
  };

  const showModal = () => {
    // setOrdenDialog(true);
  };

  useEffect(() => {
    getInfo2(selectedEnc);
  }, [selectedEnc]);

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoPase
        values={values}
        setValues={setValues}
        handleInputChange={handleInputChange}
        handleChange={handleChange}
        habilitar={habilitar}
        setHabilitar={setHabilitar}
        areas={areas}
        userSolicitar={userSolicitar}
        motivos={motivos}
        vehiculos={vehiculos}
        motoristas={motoristas}
        proveedor={proveedor}
        toast={toast}
        agregarNuevaFila={agregarNuevaFila}
        detalles={detalles}
        setDetalles={setDetalles}
        guardarPase={guardarPase}
        getInfo2={getInfo2}
        selected={selected}
        setSelected={setSelected}
        getInfo={getInfo}
        habilitarRetorno={habilitarRetorno}
        setHabilitarRetorno={setHabilitarRetorno}
        informacionDropdown={informacionDropdown}
      ></EncabezadoPase>

      <Card
        contenido={
          <div style={{ height: "60vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
    </div>
  );
};

export default PasesSalidaCRUD;
